import styled from 'styled-components';

export const AppStyled = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 24px;
  padding-bottom: 24px;
`;
